import api from "./client";
import type { ApiResponse } from "#/types/api";

interface SavingsData {
  totalScans: number;
  hoursSaved: number;
  costSaved: number;
  byProduct: Array<{
    productId: number;
    productName: string;
    scans: number;
    hoursSaved: number;
    costSaved: number;
  }>;
  bySite: Array<{
    siteId: number;
    siteName: string;
    scans: number;
    hoursSaved: number;
    costSaved: number;
  }>;
}

export const scanApi = {
  getSavings: (): Promise<ApiResponse<SavingsData>> => api.get("/scan/savings"),
};
